module.exports = __webpack_public_path__ + "static/media/hiw-kitchen-bg-1600x1080.1d837702.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/hiw-kitchen-bg-1600x1080.jpg
// module id = 175
// module chunks = 0